var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { align: "center", justify: "center", dense: "" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "5.5" } },
        [
          _c("v-autocomplete", {
            attrs: {
              "hide-details": "",
              label: "Prefix",
              items: _vm.prefixes,
              solo: "",
              clearable: ""
            },
            model: {
              value: _vm.configVariable.prefix,
              callback: function($$v) {
                _vm.$set(_vm.configVariable, "prefix", $$v)
              },
              expression: "configVariable.prefix"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { attrs: { cols: "5.5" } },
        [
          _c("v-text-field", {
            attrs: { "hide-details": "", label: "Key", solo: "" },
            model: {
              value: _vm.configVariable.key,
              callback: function($$v) {
                _vm.$set(_vm.configVariable, "key", $$v)
              },
              expression: "configVariable.key"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { staticClass: "pa-1", attrs: { cols: "1" } },
        [_c("AppButton", { on: { click: _vm.handleDelete } }, [_vm._v("Del")])],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }